/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { useEffect, useRef } from 'react'
import lottie from 'lottie-web'

/**********************************************************************************************************
 *   STYLE IMPORTS
 **********************************************************************************************************/
import { Loader } from './loader.styles'

/**********************************************************************************************************
*   SHARED IMPORTS
**********************************************************************************************************/
import animationData from 'assets/animations/mrcLoader.json'

/**********************************************************************************************************
*   INTERFACE
**********************************************************************************************************/
interface LottieProps {
    message?: string | undefined,
    width: number
    height: number
}

export const LoaderComponent = ({ message, width, height }: LottieProps) => {
    const element = useRef<HTMLDivElement>(null)
    const lottieInstance = useRef<any>()

    useEffect(() => {
        if (element.current) {
            lottieInstance.current = lottie.loadAnimation({
                animationData,
                container: element.current
            })
        }
    }, [animationData])

    return (
        <Loader.Container>
            <div style={{ width, height }} ref={element} />
            <Loader.Message>{message}</Loader.Message>
        </Loader.Container>
    )
}

/**********************************************************************************************************
 *   COMPONENT END
 **********************************************************************************************************/
export { LoaderComponent as Loader }
